import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { Divider, Image, Spin } from "antd";
import "./SingleProject.css";
import Header from "../Components/Header";
import Contact from "../Components/Contact.js";
import Footer from "../Components/Footer.js";


const BASE_URL = "https://manage.shokhdesign.uz"; // Update this to your backend URL

const SingleProjectPage = () => {
  const { id } = useParams(); // Get the project ID from the URL
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch project data from an API or backend
    const fetchProject = async () => {
      try {
        const response = await fetch(`${BASE_URL}/projects/${id}`); // Replace with your API endpoint
        const data = await response.json();
        setProject(data);
      } catch (error) {
        console.error("Error fetching project data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProject();
  }, [id]);

  if (loading) {
    return <Spin size="large" style={{ display: "block", margin: "20px auto" }} />;
  }

  if (!project) {
    return <h1 level={3} style={{ textAlign: "center" }}>Project not found</h1>;
  }

  return (
    <div className="single-project-container"> 
      <Header />
      <div className="back-button">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M19 12L5 12M5 12L11 18M5 12L11 6" stroke="#121212" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <Link to="/projects" className="back-button-text">All projects</Link>
      </div>
      <div className="project-detail-container">
      <h1 className="project-title" level={2}>{project.name}</h1>
      
          <img
            src={`${BASE_URL}${project.cover_photo || "/path/to/fallback-image.jpg"}`}
            alt={project.name}
            onError={(e) => (e.target.src = "/path/to/fallback-image.jpg")}
            className="project-detail-cover"
          />
       
       <div className="project-detail-content">
       
       <div className="project-detail-info">
       <div className="project-detail-additional-info">
          <div className="project-detail-additional-info-content" span={8}><b className="add-info-title">Year:</b> {project.year}</div>
          <div className="project-detail-additional-info-content" span={8}><b className="add-info-title">Client:</b> {project.client}</div>
          <div className="project-detail-additional-info-content" span={8}><b className="add-info-title">Service:</b> {project.service}</div>
        </div>
        <Divider/>
        <div className="project-detail-main-info">
        <div className="project-detail-main-info-content">
        <h2 className="project-detail-title" level={4}>Overview</h2>
        <h3 className="project-detail-description">{project.overview}</h3>
        </div>
        <Divider/>
        <div className="project-detail-main-info-content">
        <h2 className="project-detail-title" level={4}>My Role</h2>
        <h3 className="project-detail-description">{project.my_role}</h3>
        </div>
        </div>
        <Divider/>
        {project.project_url && (
          <a className="project-detail-visit-button" href={project.project_url} target="_blank" rel="noopener noreferrer">Visit project</a>
        )}
        </div>

        <div className="project-detail-media">
        {project.media && project.media.length > 0 && (
          <>
            
            
            <div className="project-detail-media" >
              {project.media.map((media, index) => (
                <div key={index} span={8}>
                  {media.media_type === "image" && (
                    <Image
                      src={`${BASE_URL}${media.media_file}`}
                      alt={`Media ${index + 1}`}
                      preview={true}
                    />
                    
                  )}
                  {media.media_type === "video" && (
                    <video controls style={{ width: "100%" }}>
                      <source src={`${BASE_URL}${media.media_file}`} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  )}
                </div>
              ))}
              
            </div>
          </>
        )}
        </div>
        </div>
    
      </div>
      <Contact />
      <Footer />
    </div>
  );
};

export default SingleProjectPage;
